import { NgModule } from '@angular/core';
import { DecimalPipe } from "@angular/common";
import { DaysAgoPipe } from '../requests/common/days-ago.pipe';
import { DisplayNumberPipe } from '../shared/pipes/display-number.pipe';
import { CountryFromCodePipe } from '../shared/pipes/country-code.pipe';
import { SplitUpperCasePipe } from '../shared/pipes/split-upper-case.pipe';
import { TicketStateToStatusPipe } from '../requests/common/ticket-state-to-status.pipe';
import { RadarTableCsvHelper } from '../radar/radar-table/radar-table-csv-helper';
import { RequestsTableCsvHelper } from '../requests/requests-table/requests-table-csv-helper';
import { SystemsTableCsvHelper } from '../systems/systems-home/systems-table/systems-table-csv-helper';
import { TrashSystemsTableCsvHelper } from '../unused-assets/trash-systems/trash-systems-table-csv-helper';
import { EmployeesTableCsvHelper } from '../employees/employees-managment/employees-table/employees-table-csv-helper';
import {
    PiiDataTypesTableCsvHelper
} from "../pii-classifier/pii-system-findings/pii-system-data-types/data-types-table/data-types-table-csv-helper";
import {DataTypeMatchesFormatPipe} from "../data-types/pipes/data-type-matches-format.pipe";
import {
  PiiSchemasTableCsvHelper
} from "../pii-classifier/pii-system-findings/pii-system-schema/schema-table/schema-table-csv-helper";
import { SystemFieldIdToNamePipe } from "../systems/pipes/system-field-id-to-name.pipe";
import { SystemUsageLabelPipe } from "../systems/pipes/system-usage-label.pipe";
import { LocationCodesToTextPipe } from '../shared/pipes/location-codes-to-text.pipe';
import { AiAssessmentsTableCsvHelper } from '../ai-assessments/services/ai-assessments-table-csv-helper';
import { AiAssessmentTemplateNamePipe } from '../ai-assessments/pipes/ai-assessment-template-name.pipe';
import { AssessmentStatusPipe } from '../ai-assessments/pipes/assessment-status.pipe';
import { AiAssessmentsExportHelper } from '../ai-assessments/services/ai-assessments-export-helper';
import { RiskRegistryTableCsvHelper } from '../risks/services/risk-registry-table-csv-helper';
import { CollaboratorsChipPipe } from '../ai-assessments/pipes/collaborators-chip.pipe';
import { DataSubjectIdToNamePipe } from '../ai-assessments/pipes/data-subject-id-to-name.pipe';
import { ActivityFieldIdToNamePipe } from '../ai-assessments/pipes/activity-field-id-to-name.pipe';
import { RiskCalulationPipe } from '../ai-assessments/pipes/risk-calulation.pipe';
import { RiskCalulationToTextPipe } from '../ai-assessments/pipes/risk-calculation-to-text.pipe';
import { IntegrationPreviewCsvHelper } from '../dsr/dsr-ticket/dsr-ticket-content/dsr-ticket-processing/dialogs/integrations-preview-dialog/integrations-preview-csv-helper';
import { AiAssessmentLabelsPipe } from '../ai-assessments/pipes/ai-assessment-labels.pipe';
import { ReviewDateDiffPipe } from '../ai-assessments/ai-assessments-page/ai-assessment-review-date-dialog/review-date-diff.pipe';
import { SystemsEmployeesTableCsvHelper } from '../employees/employees-managment/employees-table/systems-view-panel/systems-employees-table-csv-helper';
import { AgentIdToNamePipe } from '../shared/pipes/agent-id-to-name.pipe';

const standalonePipes = [
    DaysAgoPipe,
    CountryFromCodePipe,
    DisplayNumberPipe,
    SplitUpperCasePipe,
    TicketStateToStatusPipe,
    RiskCalulationPipe,
    RiskCalulationToTextPipe,
    DataTypeMatchesFormatPipe,
    SystemFieldIdToNamePipe,
    DataSubjectIdToNamePipe,
    ActivityFieldIdToNamePipe,
    LocationCodesToTextPipe,
    SystemUsageLabelPipe,
    AiAssessmentTemplateNamePipe,
    AssessmentStatusPipe,
    CollaboratorsChipPipe,
    ReviewDateDiffPipe,
    AgentIdToNamePipe
];

@NgModule({
  imports: [
    ...standalonePipes
  ],
  providers: [
    ...standalonePipes,
    RadarTableCsvHelper,
    PiiDataTypesTableCsvHelper,
    PiiSchemasTableCsvHelper,
    SystemsTableCsvHelper,
    RequestsTableCsvHelper,
    EmployeesTableCsvHelper,
    TrashSystemsTableCsvHelper,
    RiskRegistryTableCsvHelper,
    AiAssessmentsTableCsvHelper,
    CollaboratorsChipPipe,
    DecimalPipe,
    AiAssessmentsExportHelper,
    IntegrationPreviewCsvHelper,
    AiAssessmentLabelsPipe,
    SystemsEmployeesTableCsvHelper
  ]
})
export class CsvConvertorModule {}